import Link from "next/link";
import Image from "next/image";
import { appendUtmParams } from "@/lib/utm";
import { NavLinkProps } from "../utils/types";

export const NavLink = ({ href, title, description, onClick }: NavLinkProps) => {
  return (
    <Link
      href={appendUtmParams(href)}
      prefetch={false}
      onClick={onClick}
      className="group block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
    >
      <div className="flex flex-row items-center justify-between">
        <div className="space-y-1">
          <div className="flex flex-row items-center gap-1 text-sm font-medium leading-none">
            {title}
            <Image
              src="https://cdn-crayo.com/lp/public/rightArrow.png"
              alt="arrow"
              width={10}
              height={10}
              className="-translate-x-4 transform opacity-0 transition-all duration-300 ease-in-out group-hover:translate-x-0 group-hover:opacity-100"
              draggable={false}
              style={{
                userSelect: "none",
                pointerEvents: "none",
                touchAction: "none",
              }}
            />
          </div>
          {description && (
            <p className="line-clamp-2 text-xs leading-snug text-muted-foreground">{description}</p>
          )}
        </div>
      </div>
    </Link>
  );
};
